module.exports = __webpack_public_path__ + "img/logo-revs-negro-197x69.0e6b998f.png";